module.exports = __webpack_public_path__ + "3be90e390846c112d07c4c02a8b33f2a.png";